/**
 * i18n bootstrap. Russian is the only locale (ADR-0005, CLAUDE.md §2.2).
 *
 * Most user-visible strings in this SPA are either inline Russian literals
 * or — for the interview itself — sealed prompt text rendered by the
 * backend. i18next is reserved for the handful of shared chrome strings.
 */
import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { ru } from "./locales/ru";

void i18next.use(initReactI18next).init({
  resources: { ru: { translation: ru } },
  lng: "ru",
  fallbackLng: "ru",
  interpolation: { escapeValue: false },
});

export default i18next;
